import { css } from '@emotion/css';
import { colors } from 'constants/theme';

const accountHeaderStyles = {
    groupAction: css`
        position: absolute;
        top: calc(100% + 3px);
        left: -300px;
        z-index: 10;
        box-shadow: 1px 4px 4px 0px rgba(0, 0, 0, 0.5);
        overflow: hidden;
        max-height: 0;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transform: translateY(-8px);
        display: flex;
        flex-direction: row;
        transition: max-height 280ms ease, opacity 180ms ease, transform 220ms ease, visibility 0s linear 280ms;
    `,
    groupActionOpen: css`
        max-height: 520px;
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translateY(0);
        transition: max-height 320ms ease, opacity 180ms ease, transform 220ms ease;

        .itemMenu {
            animation: accountMenuRow 240ms ease both;
        }
        .itemMenu:nth-of-type(2) { animation-delay: 24ms; }
        .itemMenu:nth-of-type(3) { animation-delay: 48ms; }
        .itemMenu:nth-of-type(4) { animation-delay: 72ms; }
        .itemMenu:nth-of-type(5) { animation-delay: 96ms; }
        .itemMenu:nth-of-type(6) { animation-delay: 120ms; }

        @keyframes accountMenuRow {
            from { opacity: 0; transform: translateX(-10px); }
            to { opacity: 1; transform: translateX(0); }
        }
    `,
    groupActionInner: css`
        background: ${colors.bgTitle};
        background-image: linear-gradient(to bottom, ${colors.primary}, ${colors.darkPrimary});
        border: 1px solid #c9820a;
        display: flex;
        flex-direction: column;
        .icon {
            width: 20px;
            height: 20px;
        }
        .title {
            color: #ffd98a;
        }
        .viewTitle {
            display: flex;
            padding-left: 20px;
            width: 170px;
            align-items: center;
            gap: 8px;
        }
        .itemMenu {
            display: flex;
            flex-direction: row;
        }

        .borderBottom {
            border-bottom: 1px solid rgba(255, 217, 138, 0.35);
        }
        .borderRight {
            border-right: 1px solid rgba(255, 217, 138, 0.35);
        }
        .contentMenu {
            width: 550px;
            background-color: ${colors.bgTitle};
            padding-top: 15px;
            padding-bottom: 15px;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            color: white;

            .line {
                width: 1px;
                height: 20px;
                background-color: rgba(255, 217, 138, 0.35);
            }

            .itemContentMenu {
                display: flex;
                align-items: center;
                gap: 10px;
                padding-left: 20px;
                font-size: 14px;
                font-weight: 300;
                .titleContent {
                    cursor: pointer;
                    &:hover {
                        color: ${colors.secondary};
                    }
                }
            }
        }
    `,
    groupActionCol: css`
        width: 115px;

        h6 {
            font-size: 14px;
            margin-bottom: 12px;
        }
    `,
    groupActionList: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
    accountActionItem: css`
        padding: 6px 2px;
        border: 1px solid #d9d9d9;
        border-radius: 8px;
        text-align: center;
        cursor: pointer;
        transition: 0.25s;
        img {
            width: 20px;
        }
        p {
            font-size: 12px;
        }
        &:hover {
            background: #e9f7f3;
            border-color: ${colors.darkPrimary};
        }
    `,
};
export default accountHeaderStyles;
